import React from 'react';
import _ from 'lodash';
import { Padding } from 'components/base/layout-components';
import Autocomplete from 'components/base/Autocomplete';
import { lightColorPalette } from '@linearb/linui-common';
import { Body2 } from '@linearb/linui-common/typography';
import { Stack } from '@mui/material';
import { StyledSectionTitle } from './CreateEditProjectModal.style';

const getIterationsRegextInput = ({ title, values, onChange, dataTestId }) => {
  return (
    <Stack paddingTop='1rem' spacing={1}>
      <Body2 color={lightColorPalette.lbTextSubdued}>{title}</Body2>
      <Autocomplete
        width='40rem'
        multiple
        placeholder={`Input regex (press Enter)`}
        defaultValue={[]}
        value={values}
        chipInput
        onChange={onChange}
        data-testid={dataTestId}
      />
    </Stack>
  );
};

const IterationsSettings = ({
  includeIterations = [],
  setIncludeIterations = _.noop,
  excludeIterations = [],
  setExcludeIterations = _.noop
}) => {
  return (
    <Padding b='normal' t='normal' data-testid='iterations-container-testid'>
      <StyledSectionTitle>Iterations Control</StyledSectionTitle>
      {getIterationsRegextInput({
        title:
          'Use regular expressions to choose which iterations to include in your projects.',
        values: includeIterations,
        onChange: values => setIncludeIterations(values),
        dataTestId: 'include-iterations-autocomplete-testid'
      })}
      {getIterationsRegextInput({
        title:
          'Use regular expressions to specify which iterations should be left out of your projects.',
        values: excludeIterations,
        onChange: values => setExcludeIterations(values),
        dataTestId: 'exclude-iterations-autocomplete-testid'
      })}
    </Padding>
  );
};

export default IterationsSettings;
